import {
  BALANCE_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT,
  EXPOSURE_AMOUNT,
  ORIGIN_RESTRICTION,
  PLAYER_PROFILE,
  SET_DEMO_USER,
} from "./types";

const IsDemouserStorageKey = "isdmu";

const initialState = {
  isAuth: sessionStorage.getItem("token") !== null,
  token:
    sessionStorage.getItem("token") !== null
      ? sessionStorage.getItem("token")
      : null,
  user:
    localStorage.getItem("user") !== null
      ? JSON.parse(localStorage.getItem("user"))
      : null,
  wallet:
    localStorage.getItem("wallet") !== null
      ? JSON.parse(localStorage.getItem("wallet"))
      : null,
  exposureAmount:
    localStorage.getItem("exposureAmount") !== null
      ? localStorage.getItem("exposureAmount")
      : null,
  originRestriction: {
    userBlocked: false,
    errorMessage: "",
  },
  isDemoUser: sessionStorage.getItem(IsDemouserStorageKey) === "true" || false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_SUCCESS:
      sessionStorage.setItem("token", payload.token);
      return {
        ...state,
        isAuth: true,
        token: payload.token,
        // user: payload.user,
      };
    case BALANCE_SUCCESS:
      delete payload.status;
      localStorage.setItem("wallet", JSON.stringify(payload));
      return {
        ...state,
        wallet: payload,
      };
    case EXPOSURE_AMOUNT:
      localStorage.setItem("exposureAmount", payload);
      return {
        ...state,
        exposureAmount: payload,
      };
    case LOGOUT:
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      localStorage.removeItem("appDetails");
      localStorage.removeItem("exposureAmount");
      sessionStorage.clear();
      return {
        ...state,
        isAuth: false,
      };
    case ORIGIN_RESTRICTION:
      return {
        ...state,
        originRestriction: payload,
      };
    case PLAYER_PROFILE:
      localStorage.setItem("user", JSON.stringify(payload));
      return {
        ...state,
        user: payload,
      };
    case SET_DEMO_USER:
      sessionStorage.setItem(IsDemouserStorageKey, payload);
      return {
        ...state,
        isDemoUser: payload,
      };
    default:
      return state;
  }
};
